import { useEffect, useState } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { GeneralModal } from '../components-molecules';
import { ButtonWithLoadingIndicator } from '../components-atoms';
import { enqueueUpcExport } from '../redux/actions/upc';
import { colours } from '../constants/theme';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircle';

export interface IUPCExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDone: () => void;
}

export default function UPCExportModal(props) {
  const classes = useStyles();
  const { isOpen } = props;
  const [isReady, setIsReady] = useState(false);
  const [message, setMessage] = useState<string>();

  useEffect(() => {
    if (isOpen) {
      onDownload();
    }
  }, [isOpen]);

  const onDownload = () => {
    enqueueUpcExport((res: string) => {
      setIsReady(true);
      setMessage(res);
    }, (err) => {
      console.log('Err', err);
      setIsReady(true);
      setMessage('Error exporting UPC template');
    });
  }

  const onClose = () => {
    props.onClose();
  }

  const renderContent = () => {
    if (isReady && message) {
      return (
        <Grid item xs={12} className={classes.inProgress}>
          <div className={classes.loadingIconContainer}>
            <CheckCircleOutlineIcon style={{ fontSize: 40, color: colours.primary }} />
          </div>
          <Typography align="center" variant="h5">
            {message}
          </Typography>
        </Grid>
      )
    }
    return null;
  }

  return (
    <GeneralModal
      title="Export UPC Template"
      visible={isOpen}
      onClose={onClose}
      modalWidth="560px"
    >
      <GeneralModal.ContentArea className={classes.content}>
        <Grid container>
          {renderContent()}
        </Grid>
      </GeneralModal.ContentArea>
      <GeneralModal.ButtonArea>
        <ButtonWithLoadingIndicator
          title="Done"
          onClick={onClose}
        />
      </GeneralModal.ButtonArea>
    </GeneralModal >
  )
}

const useStyles = makeStyles((theme) => ({
  content: {
    marginTop: 16,
    marginBottom: 32
  },
  loadingIconContainer: {
    display: 'flex',
    width: 64,
    height: 64,
    borderRadius: 32,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 14, 175,0.1)',
  },
  rotatingIcon: {
    animation: '$rotate 2s linear infinite',
  },
  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '50%': {
      transform: 'rotate(360deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  inProgress: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    padding: 16
  },
  separator: {
    width: '100%',
    margin: '16px 0',
    border: '1px solid rgba(0,0,0,0.054)'
  },
  queueMsg: {
    gap: 8,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  success: {
    color: 'rgb(76, 175, 80)'
  },
  error: {
    color: 'rgb(255, 75, 52)'
  }
}));